// ============================================================================
// Widget — Aging Bucket Mix
// Stacked bar of outstanding by DPD bucket — exec sees the tail at a glance.
// ============================================================================
import React from 'react';
import ReactECharts from 'echarts-for-react';
import WidgetShell from './WidgetShell';
import { mockAgingBuckets, fmtAmount, fmtCount } from '../executiveMockData';

const AgingBucketMixWidget: React.FC = () => {
  const labels = mockAgingBuckets.map(b => b.label);
  const counts = mockAgingBuckets.map(b => b.accountCount);
  const amounts = mockAgingBuckets.map(b => b.outstanding);

  // Bucket gets redder as DPD grows.
  const colors = ['#34d399', '#86efac', '#fcd34d', '#fb923c', '#f87171', '#dc2626'];

  const option = {
    grid: { left: 50, right: 56, top: 16, bottom: 28 },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params: any[]) => {
        const idx = params[0].dataIndex;
        const b = mockAgingBuckets[idx];
        return `<strong>${b.label} DPD</strong><br/>
                Accounts: ${fmtCount(b.accountCount)}<br/>
                Outstanding: ${fmtAmount(b.outstanding)}`;
      },
    },
    xAxis: {
      type: 'category',
      data: labels,
      axisTick: { show: false },
      axisLabel: { fontSize: 11 },
    },
    yAxis: [
      {
        type: 'value',
        name: '₹ Cr',
        nameTextStyle: { fontSize: 10, color: '#64748b' },
        axisLabel: {
          fontSize: 10,
          formatter: (v: number) => (v / 1_00_00_000).toFixed(1),
        },
        splitLine: { lineStyle: { color: '#e5e7eb', type: 'dashed' } },
      },
      {
        type: 'value',
        name: 'Accounts',
        nameTextStyle: { fontSize: 10, color: '#64748b' },
        axisLabel: { fontSize: 10 },
        splitLine: { show: false },
      },
    ],
    series: [
      {
        name: 'Outstanding',
        type: 'bar',
        yAxisIndex: 0,
        barWidth: 26,
        data: amounts.map((v, i) => ({ value: v, itemStyle: { color: colors[i], borderRadius: [3, 3, 0, 0] } })),
      },
      {
        name: 'Accounts',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        symbol: 'circle',
        symbolSize: 7,
        lineStyle: { width: 2, color: '#1e3a8a' },
        itemStyle: { color: '#1e3a8a' },
        data: counts,
      },
    ],
  };

  return (
    <WidgetShell
      title="Aging Bucket Mix"
      subtitle="Outstanding by DPD bucket + account count overlay"
    >
      <ReactECharts option={option} style={{ height: 220, width: '100%' }} />
    </WidgetShell>
  );
};

export default AgingBucketMixWidget;
